import { render, staticRenderFns } from "./xingyou.vue?vue&type=template&id=53e648ca&scoped=true"
import script from "./xingyou.vue?vue&type=script&lang=js"
export * from "./xingyou.vue?vue&type=script&lang=js"
import style0 from "./xingyou.vue?vue&type=style&index=0&id=53e648ca&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53e648ca",
  null
  
)

export default component.exports